export default __webpack_public_path__ + "assets/images/31bfe974cf1c59f1d5b30e3825b0d0e3.svg";